"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lang_1 = __importDefault(require("../../../lang"));
function numeric() {
    /* eslint-disable */
    return this.matches(/^\d+$/, (0, lang_1.default)().validation.integer());
    /* eslint-enable */
}
exports.default = numeric;
